import OAuth from "./oauth"
import auth from "./auth"

export default {
  get(path, params) {
    return this.execute("GET", path, params)
  },

  post(path, params, body) {
    return this.execute("POST", path, params, body)
  },

  put(path, params, body) {
    return this.execute("PUT", path, params, body)
  },

  patch(path, params, body) {
    return this.execute("PATCH", path, params, body)
  },

  delete(path, params) {
    return this.execute("DELETE", path, params)
  },

  async execute(method, path, params, body, refreshAndRetry = true) {
    let options = {
      method: method,
      headers: { accept: "application/json" },
      params: params || {},
    }
    let url = new URL(`${process.env.VUE_APP_API_ORIGIN}${path}`)

    // refresh access token if needed (proactive)
    if (OAuth.shouldRefresh()) {
      await this._refresh()
    }

    // authorize request
    if (OAuth.tokenType === "bearer") {
      options.headers.authorization = `Bearer ${OAuth.accessToken}`
    } else {
      throw new Error(`Unsupported OAuth token type ${OAuth.tokenType}`)
    }

    if (params) {
      Object.keys(params)
        .forEach(key => url.searchParams.append(key, params[key]))
    }

    if (body) {
      if (body instanceof FormData) {
        options.body = body
      } else {
        options.headers["content-type"] = "application/json"
        options.body = JSON.stringify(body)
      }
    }

    let response
    try {
      response = await fetch(url, options)
    } catch (ex) {
      throw new Error(ex.message)
    }

    switch (response.status) {
      case 204:
        return
      case 401:
        if (refreshAndRetry) {
          // refresh access token if needed (reactive) then retry the request
          await this._refresh()
          return this.execute(method, path, params, body, false)
        }
        return this.onunauthorized(response, method, url)
      case 422:
        throw new Error((await response.json()).errors[0])
    }

    if (response.ok) {
      return response.json()
    }
    return this.onerror(response, method, url)
  },

  onunauthorized(response, method, url) {
    window.console.error(`ERROR: unauthorized ${method} request to ${url}`)
    throw new Error(response && response.status)
  },

  onerror(response) {
    throw new Error(`${response.status} ${response.statusText}`)
  },

  _refresh() {
    return auth.refresh().then(result => {
      if (!result) this.onunauthorized()
    })
  }
}
